export function ourStorySlider() {
    let $slider = $(".story-slider");
    let $sliderNav = $(".story-slider-nav");
    let slides;
    let navSlides;
    let prevSlide = 0;

    $(".story-slide").each(function () {

        if (!$(this).find(".story-slide-img").length) {
            $(this).addClass("no-image");
        }
    });

    $slider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: false,
        arrows: false,
        prevArrow: `<button type="button" class="slick-prev slick-arrow">
                            <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 11H2M2 11L12.5 1M2 11L12.5 21" stroke="#151B20" stroke-width="1.5"/>
                            </svg>
                        </button>`,
        nextArrow: `<button type="button" class="slick-next slick-arrow">
                        <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26 11H2M2 11L12.5 1M2 11L12.5 21" stroke="#151B20" stroke-width="1.5"/>
                        </svg>
                    </button>`,
        asNavFor: $sliderNav,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    variableWidth: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    variableWidth: true,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    slidesToShow: 4,
                    variableWidth: true,
                }
            },
        ]
    });

    $sliderNav.slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: $slider,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 7,
                }
            },
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 7.7,
                }
            },
        ]
    });

    slides = $slider.find(".slick-slide");

    navSlides = $sliderNav.find(".slick-slide");

    $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide){
        if (nextSlide === slides.length - 1) {
            $(this).addClass("show-last-slide");
        } else {
            $(this).removeClass("show-last-slide");
        }
    });

    $sliderNav.on("afterChange", function (event, slick, currentSlide){

        if (prevSlide > currentSlide) {
            for (let j = currentSlide; j < navSlides.length; j++) {
                $(navSlides).eq(j).removeClass("before-current-year");
            }
        } else {
            for (let i = 0; i < currentSlide; i++) {

                $(navSlides).eq(i).addClass("before-current-year");

                if ($(navSlides).eq(i).hasClass("slick-current")) {
                    return;
                }
            }
        }

        prevSlide = currentSlide;
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/ourStorySlider.js